<template>
  <div>
    <div class="maskPanel" v-if="show || showSubmitSuccess"></div>
    <div class="modal" v-if="show">
      <div style="text-align: left; width: calc(100% - 80px);">
        <div style="display: flex; justify-content: space-between;">
          <h1 style="margin-bottom: 10px;">Requests For Spatial 3D Data</h1>
        </div>
        <h4 style="font-weight: 100;">Join WorldKey to discover how our AI-driven 3D solutions can empower your vision.
          Book a 1:1 demo to get started today.</h4>
      </div>
      <form @submit.prevent="handleSubmit" style="width: calc(100% - 80px);">
        <!-- 前四个字段，两个一行 -->
        <div class="form-row">
          <!-- First Name -->
          <div class="form-group">
            <input
              v-model="form.firstName"
              type="text"
              placeholder="First name*"
              id="firstName"
              maxlength="255"
              :class="{'error': errors.firstName}"
            />
            <span v-if="errors.firstName" class="error-message">{{ errors.firstName }}</span>
          </div>

          <!-- Last Name -->
          <div class="form-group">
            <input
              v-model="form.lastName"
              type="text"
              placeholder="Last name*"
              id="lastName"
              maxlength="255"
              :class="{'error': errors.lastName}"
            />
            <span v-if="errors.lastName" class="error-message">{{ errors.lastName }}</span>
          </div>
        </div>

        <div class="form-row">
          <!-- Company Name -->
          <div class="form-group">
            <input
              v-model="form.companyName"
              type="text"
              placeholder="Company name*"
              id="companyName"
              maxlength="255"
              :class="{'error': errors.companyName}"
            />
            <span v-if="errors.companyName" class="error-message">{{ errors.companyName }}</span>
          </div>

          <!-- Job Title -->
          <div class="form-group">
            <input
              v-model="form.jobTitle"
              type="text"
              placeholder="Job title*"
              id="jobTitle"
              maxlength="255"
              :class="{'error': errors.jobTitle}"
            />
            <span v-if="errors.jobTitle" class="error-message">{{ errors.jobTitle }}</span>
          </div>
        </div>

        <!-- Work Email -->
        <div class="form-group">
          <input
            v-model="form.workEmail"
            placeholder="Work email*"
            id="workEmail"
            pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
            maxlength="255"
            :class="{'error': errors.workEmail}"
          />
          <span v-if="errors.workEmail" class="error-message">{{ errors.workEmail }}</span>
        </div>

        <!-- Project Budget -->
        <div class="form-group">
          <label style="margin-bottom: 12px;">Project Budget:*</label>
          <div class="radio-group">
            <label class="radio-label">
              <input
                type="radio"
                name="project-budget"
                value="0"
                v-model="form.projectBudget"
              />
              <span>&lt;$10K</span>
            </label>
            <label class="radio-label">
              <input
                type="radio"
                name="project-budget"
                value="1"
                v-model="form.projectBudget"
              />
              <span>$10K-50K</span>
            </label>
            <label class="radio-label">
              <input
                type="radio"
                name="project-budget"
                value="2"
                v-model="form.projectBudget"
              />
              <span>$50K-1M</span>
            </label>
            <label class="radio-label">
              <input
                type="radio"
                name="project-budget"
                value="3"
                v-model="form.projectBudget"
              />
              <span>$1M+</span>
            </label>
          </div>
          <span v-if="errors.projectBudget" class="error-message">{{ errors.projectBudget }}</span>
        </div>

        <!-- Job Description -->
        <div class="form-group">
        <textarea
          v-model="form.jobDescription"
          placeholder="Please describe your project in detail(data detail, volume, timeline, budget, etc)*"
          id="jobDescription"
          :class="{'error': errors.jobDescription}"
        ></textarea>
          <span v-if="errors.jobDescription" class="error-message">{{ errors.jobDescription }}</span>
        </div>

        <!-- 同意协议的 checkbox -->
        <div class="checkbox-container">
          <label style="display: flex; align-items: stretch;">
            <input v-model="form.agree" type="checkbox" style="margin-right: 12px; transform: scale(1.5);" />
            <span>I agree to receive communications from WorldKey, and I understand WorldKey will process my personal information in accordance with WorldKey's Privacy Policy.*</span>
          </label>
          <div v-if="errors.agree" class="error-message">{{ errors.agree }}</div>
        </div>

        <!-- 提交按钮 -->
        <div class="form-group form-actions">
          <button type="button" class="cancel-btn" @click="closeMask">Cancel</button> <!-- 左边的取消按钮 -->
          <button type="submit" class="submit-btn">Submit</button> <!-- 右边的提交按钮 -->
        </div>
      </form>

    </div>
    <div class="modal" v-if="showSubmitSuccess" style="padding: 75px 75px 50px 75px;">
      <img src="../assets/logo/biglogo.png" style="width: 200px;" />
      <span style="font-size: 16px; text-align: center;">
        Thanks for choosing WorldKey! We’ve received your request and our team is now reviewing it. You will hear from us within 5 business days.
      </span>
      <button class="submit-btn" @click="showSubmitSuccess = false" style="margin-top: 20px; border: none; font-weight: 600; padding: 12px 18px; font-size: 16px;">Back to home</button>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import * as api from '../service/getData'

export default {
  name: 'BuyData',
  data () {
    return {
      show: false,
      showSubmitSuccess: false,
      form: {
        firstName: '',
        lastName: '',
        companyName: '',
        jobTitle: '',
        workEmail: '',
        projectBudget: '',
        jobDescription: '',
        agree: false
      },
      errors: {
        firstName: false,
        lastName: false,
        companyName: false,
        jobTitle: false,
        workEmail: false,
        projectBudget: false,
        jobDescription: false,
        agree: false
      }
    }
  },
  methods: {
    showBuyData () {
      this.show = true
    },
    closeMask () {
      this.show = false
    },
    validateForm () {
      let valid = true
      this.errors = {}

      // 验证必填字段
      if (!this.form.firstName) {
        this.errors.firstName = 'First name is required.'
        valid = false
      }
      if (!this.form.lastName) {
        this.errors.lastName = 'Last name is required.'
        valid = false
      }
      if (!this.form.companyName) {
        this.errors.companyName = 'Company name is required.'
        valid = false
      }
      if (!this.form.jobTitle) {
        this.errors.jobTitle = 'Job title is required.'
        valid = false
      }
      if (!this.form.workEmail) {
        this.errors.workEmail = 'Work email is required.'
        valid = false
      } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.form.workEmail)) {
        this.errors.workEmail = 'Wrong email format. Please correct it.'
        valid = false
      }
      if (!this.form.projectBudget) {
        this.errors.projectBudget = 'Please select a budget.'
        valid = false
      }
      if (!this.form.jobDescription) {
        this.errors.jobDescription = 'Description is required.'
        valid = false
      }
      if (!this.form.agree) {
        this.errors.agree = 'Please read and agree to the agreement.'
        valid = false
      }
      return valid
    },
    async handleSubmit () {
      if (this.validateForm()) {
        const obj = {
          address: Cookies.get('address') || '',
          first_name: this.form.firstName,
          last_name: this.form.lastName,
          company_name: this.form.companyName,
          job_title: this.form.jobTitle,
          work_email: this.form.workEmail,
          project_budget: this.form.projectBudget,
          description: this.form.jobDescription
        }
        console.log(obj)
        const res = await api.createDemand(obj)
        this.$prompt.success('Create demand success')
        this.closeMask()
        this.showSubmitSuccess = true
        // alert('Form submitted successfully!');
      }
    }
  }
}
</script>

<style scoped>
.modal {
  position:fixed;
  z-index:100;
  background:#000000dd;
  top:50%;
  left:50%;
  transform: translate(-50%,-50%);
  display: flex;
  width: 680px;
  padding: 44px 0px;
  flex-direction: column;
  align-items: center;
  border-radius: var(--Corner01, 24px);
  gap: 20px;
  border: 2px solid #ffffff;
}
/* 基本样式 */
.form-container {
  background: #111;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  padding: 40px;
  width: 100%;
  max-width: 600px;
}

.form-row {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.form-group {
  margin-bottom: 25px;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 12px 18px;
  border: 1px solid #fff;
  border-radius: 6px;
  background-color: #000;
  color: #fff;
  font-size: 16px;
  font-weight: 400;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.3s ease, background-color 0.3s ease;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  border-color: #ff7e5f;
  background-color: #333;
}

.form-group input.error,
.form-group textarea.error {
  //border-color: red;
}

.error-message {
  color: red;
  font-size: 12px;
  margin-top: 5px;
}

.checkbox-container {
  margin-bottom: 20px;
}

.checkbox-container label {
  color: #fff;
  font-size: 14px;
}

.radio-group {
  display: flex;
  justify-content: left;
}

.radio-label {
  margin-right: 32px;
  font-size: 16px;
  color: #fff;
  display: flex;
  align-items: center;
}
.radio-label span {
  margin-left: 8px;
}
.form-group input[type='radio'] {
  width: 20px;
  height: 20px;
}
.maskPanel {
  top:0;
  left:0;
  position:fixed;
  z-index:99;
  opacity: 0.7;
  background: var(--neutral-900, #101313);
  width:100%;
  height:100%;
}
.form-actions {
  display: flex;
  justify-content: space-between; /* 左右对齐分布 */
  flex-direction: row;
  gap: 20px; /* 两个按钮之间的间距 */
  margin: 32px 0 0 0;
}

.submit-btn {
  padding: 12px 36px;
  background: var(--button-linear-default, linear-gradient(90deg, #0FF 25.99%, #6DFBB7 100%));
  border: 1px solid #fff;
  border-radius: 6px;
  color: black;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.submit-btn:hover {
  background-color: #feb47b; /* 提交按钮的悬停效果 */
}

.cancel-btn {
  padding: 12px 36px;
  background-color: #000;
  border: 1px solid #fff;
  border-radius: 6px;
  color: white;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.cancel-btn:hover {
  background-color: #555; /* 取消按钮的悬停效果 */
}
</style>



// WEBPACK FOOTER //
// src/components/BuyData.vue